/* Marco Maveri — inject shoppable callouts + Chain Finder quiz into blog articles.
   Quiz → just after 2nd paragraph. Card 1 → ~45%-2. Card 2 → ~65% (or before FAQ). */
(function () {
  var moved = false;
  function tryMove() {
    if (moved) return true;
    var rte = document.querySelector('rte-formatter')
           || document.querySelector('.blog-post-content')
           || document.querySelector('.article-template__content')
           || document.querySelector('.rte');
    var cards = document.querySelectorAll('[data-mm-callout]');
    var quiz  = document.querySelector('[data-mm-quiz-trigger-inline]');
    if (!rte) return false;

    var paragraphs = [];
    rte.querySelectorAll(':scope > p').forEach(function (p) {
      if ((p.textContent || '').trim().length > 30) paragraphs.push(p);
    });
    if (paragraphs.length < 3) {
      rte.querySelectorAll('p').forEach(function (p) {
        if ((p.textContent || '').trim().length > 30 && paragraphs.indexOf(p) === -1) paragraphs.push(p);
      });
    }
    if (paragraphs.length < 3) return false;

    // FAQ heading fence for card 2
    var faqHeading = null;
    var headings = rte.querySelectorAll('h1, h2, h3');
    for (var i = 0; i < headings.length; i++) {
      if (/\bfaq\b|frequently\s+asked/i.test((headings[i].textContent || '').toLowerCase())) { faqHeading = headings[i]; break; }
    }

    var n = paragraphs.length;
    var quizIdx  = 1;                                   // after 1st paragraph
    var card1Idx = Math.max(quizIdx + 1, Math.floor(n * 0.45) - 2);
    var card2Idx = Math.min(n - 2, Math.max(card1Idx + 1, Math.floor(n * 0.65)));

    if (quiz && paragraphs[quizIdx] && !rte.contains(quiz)) {
      paragraphs[quizIdx].insertAdjacentElement('afterend', quiz);
      quiz.removeAttribute('hidden');
    }
    if (cards[0] && paragraphs[card1Idx]) {
      paragraphs[card1Idx].insertAdjacentElement('afterend', cards[0]);
      cards[0].removeAttribute('hidden');
    }
    if (cards[1]) {
      if (faqHeading && rte.contains(faqHeading)) {
        faqHeading.parentNode.insertBefore(cards[1], faqHeading);
      } else if (paragraphs[card2Idx]) {
        paragraphs[card2Idx].insertAdjacentElement('afterend', cards[1]);
      }
      cards[1].removeAttribute('hidden');
    }

    moved = true;
    return true;
  }
  function start() {
    if (tryMove()) return;
    var attempts = 0;
    var iv = setInterval(function () {
      attempts++;
      if (tryMove() || attempts > 40) clearInterval(iv);
    }, 200);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  window.addEventListener('load', start);
})();
